<template lang="pug">
  section.collection
    p NOT FOUND
    <router-view/>
</template>

<script>

export default {
  name: 'not-found'
}
</script>
